import axios from 'axios';

export const fetchSuggestQuery = async (phrase: string) => {
  const response = await axios.get<{ suggestions: string[] }>(
    `/api/v3/suggest/query`,
    {
      params: {
        input_word: phrase,
      },
    },
  );
  return response.data;
};
